import React from 'react'
function Settlements() {
return (
<div class="idocs-content">
   <div class="container">
      <div class="row">
         <div class="col-md-8">
            <section id="idocs_start1">
               <h1>Settlements</h1>
               <hr/>
               <p class="mt-30">Settlement is the process of transferring funds from a customer's account to a merchant's account after a successful transaction. It is an important aspect of any payment gateway as it determines how quickly the merchant can access the funds they have earned. </p>
               <p>Safexpay Payment Gateway offers the following three options for settlements. </p>
            </section>
            <section id="idocs_installation1" class="mt-60">
               <h2 id='instant-settle-neo-sec'>Instant Settlement</h2>
               <hr/>
               <p class="mt-30">
                  Instant Settlement is a feature that allows merchants to receive funds in real-time or instantly after a successful transaction. It is particularly useful for merchants who require immediate access to funds to manage their cash flow. With Instant Settlement, the merchant can receive funds 24/7, including weekends and holidays. However, there are certain conditions that need to be met before a merchant can use Instant Settlement. 
               </p>
            </section>
            <section id="idocs_html_structure1" class="mt-60">
               <h2 id='split-settle-neo-sec'>Split Settlement</h2>
               <hr/>
               <p class="mt-30">Split Settlement is a feature that allows you to split their earnings into multiple accounts. 
                  With Split Settlement, the merchant can specify the percentage of earnings that should go to each account. The payment gateway will then split the earnings accordingly and transfer them to the designated accounts. This feature is particularly useful for merchants who have multiple accounts or who need to manage their finances more efficiently.
               </p>
            </section>
            <section id="idocs_sass1" class="mt-60">
               <h2 id='demand-settle-neo-sec'>On Demand Settlement</h2>
               <hr/>
               <p class="mt-30">
                  On Demand Settlement is a feature that allows merchants to request a settlement at any time. With this feature, the merchant can choose when they want to receive their earnings rather than waiting for the scheduled settlement time. On Demand Settlement is useful for merchants who require more flexibility in managing their cash flow. 
               </p>
            </section>
         </div>
         <div class="col-md-4">
         </div>
      </div>
   </div>
</div>
)
}
export default Settlements